var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgArrowLeftActive = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "currentColor",
  "aria-hidden": true,
  viewBox: "0 0 8 12",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.556 5.546a.647.647 0 0 0 0 .908l5.333 5.36c.275.248.687.248.935 0l.632-.632c.247-.247.247-.66 0-.935l-4.234-4.26 4.234-4.234c.247-.275.247-.688 0-.935L6.824.186c-.248-.248-.66-.248-.935 0z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeftActive);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;